import { Backdrop, Box, Button, Card, CardContent, CardHeader, Chip, CircularProgress, Container, Divider, Grid, IconButton, Snackbar, Switch, FormControlLabel, TextField, Typography, Dialog, DialogTitle, DialogActions, DialogContent, Select, MenuItem, FormControl, InputLabel, CardMedia } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import AlertScreen from 'src/components/Alert';
import trLocale from 'date-fns/locale/tr';
import { styled } from '@mui/system';
import { getUser } from 'src/utils/Common';
import { base64Reader } from 'src/utils/storage/StrPhoto'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const localeMap = {
  tr: trLocale
};

const styles = {
  root: (theme) => ({
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  }),
  backdrop: {
    zIndex: 2000,
    color: '#fff'
  }
};

const StyledCardMedia = styled(CardMedia)({
  height: '200px',
  backgroundSize: 'contain',
});

const APP_OPTIONS = [
  { id: 1, name: 'Aron-Yönetim', color: '#7B61FF' },
  { id: 2, name: 'Artemis', color: '#00BCD4' },
  { id: 3, name: 'YsPortal', color: '#4CAF50' },
  { id: 4, name: 'Apollo', color: '#FF9800' },
  { id: 5, name: 'Oasis', color: '#3F51B5' }
];

const getAppColor = (name) => APP_OPTIONS.find(app => app.name === name)?.color || '#9E9E9E';

function DialogHeader({ title, onClose }) {
  return (
    <DialogTitle sx={{ pr: 6 }}>
      {title}
      <IconButton
        onClick={onClose}
        sx={{ position: 'absolute', right: 8, top: 8, color: 'grey.500' }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
  );
}

DialogHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};

function Banner() {
  const [Alert, setAlert] = useState(false);
  const [AlertType, setAlertType] = useState('');
  const [ResponseMessage, setResponseMessage] = useState('');
  const [Loading, setLoading] = useState(false);
  const [BannerData, setBannerData] = useState([]);
  const [Popup, setPopup] = useState(false);
  const [Id, setId] = useState(0);
  const [Uygulama, setUygulama] = useState(0);
  const [Aktif, setAktif] = useState(1);
  const [Aciklama, setAciklama] = useState('');
  const [Resim, setResim] = useState('');
  const [BaslangicTarihi, setBaslangicTarihi] = useState(new Date().toISOString().slice(0, 16));
  const [BitisTarihi, setBitisTarihi] = useState(new Date().toISOString().slice(0, 16));
  const [label, setLabel] = useState("Dosya seçiniz...");
  const SessionUser = getUser();
  const [avatarEmployee, setAvatarEmployee] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isDragActive, setIsDragActive] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const fileInputRef = React.useRef(null);
  const MAX_FILE_SIZE = 8072000;
  const ACCEPTED_FILE_PREFIX = 'image/';
  const setPopupOpen = (IdParam) => {
    setSelectedFiles([]);
    setUploadSuccess(false);
    setId(IdParam);
    if (IdParam !== 0) {
      getApplicationBanner(IdParam);
    } else {
      setUygulama(0);
      setAktif(1);
      setAciklama('');
      setResim('');
      setBaslangicTarihi(new Date().toISOString().slice(0, 16));
      setBitisTarihi(new Date().toISOString().slice(0, 16));
      setAvatarEmployee(null);
    }
    setPopup(true);
  }
  useEffect(() => {
    getApplicationBanner(0);
  }, []);

  const addSelectedFiles = (fileList) => {
    const incoming = Array.from(fileList || []);
    if (incoming.length === 0) {
      return;
    }
    const file = incoming[0];
    if (!file.type.startsWith(ACCEPTED_FILE_PREFIX)) {
      setAlert(true);
      setAlertType('error');
      setResponseMessage('Lütfen bir görsel dosyası seçiniz!...');
      return;
    }
    if (file.size > MAX_FILE_SIZE) {
      setAlert(true);
      setAlertType('error');
      setResponseMessage('Dosya boyutu çok büyük. Lütfen dosya boyutunu kontrol ediniz!...');
      return;
    }
    setUploadSuccess(false);
    setSelectedFiles([file]);
  };

  const handleDropFiles = (event) => {
    event.preventDefault();
    setIsDragActive(false);
    addSelectedFiles(event.dataTransfer.files);
  };

  const handleRemoveSelectedFile = () => {
    setSelectedFiles([]);
    setUploadSuccess(false);
  };

  const handleUploadClick = () => {
    if (selectedFiles.length === 0) {
      return;
    }
    const files = selectedFiles.map((file) => ({ file, meta: { name: file.name, type: file.type } }));
    const allFiles = selectedFiles.map(() => ({ remove: () => {} }));
    handleSubmit(files, allFiles);
    setSelectedFiles([]);
  };

  const handleSubmit = async (files, allFiles) => {
    setLoading(true);
    let total = files.length;
    let success = 0;
    let base64Result = "";
    for (let i = 0; i < files.length; i++) {
      const file = files[i].file;
      const meta = files[i].meta;
      if (meta.type.indexOf('image') !== -1) {
        base64Result = await base64Reader(file);
      }
    }
    setResim(base64Result);
    setUploadSuccess(true);
    setLoading(false);
  }

  const handleSave = () => {


    if (Resim === "" && Id === 0) {
      setAlert(true);
      setAlertType("error");
      setResponseMessage("Lütfen resim ekleyiniz!...");
      return;
    }
    if (Uygulama === 0) {
      setAlert(true);
      setAlertType("error");
      setResponseMessage("Lütfen uygulama seçiniz!...");
      return;
    }
    if (Aciklama === "") {
      setAlert(true);
      setAlertType("error");
      setResponseMessage("Lütfen açıklama giriniz!...");
      return;
    }
    if (BaslangicTarihi === "") {
      setAlert(true);
      setAlertType("error");
      setResponseMessage("Lütfen başlangıç tarihi giriniz!...");
      return;
    }
    if (BitisTarihi === "") {
      setAlert(true);
      setAlertType("error");
      setResponseMessage("Lütfen başlangıç tarihi giriniz!...");
      return;
    }
    if (BitisTarihi < BaslangicTarihi) {
      setAlert(true);
      setAlertType("error");
      setResponseMessage("Bitiş tarihi, başlangıç tarihinden önce olamaz!...");
      return;
    }


    setLoading(true);
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    const requestData = {
      Id: Id,
      Uygulama: Uygulama,
      Aktif: Aktif,
      Aciklama: Aciklama,
      Resim: Resim,
      BaslangicTarihi: BaslangicTarihi,
      BitisTarihi: BitisTarihi,
      UserId: SessionUser?.UserId
    };

    axios.post('/SetApolloApplicationBanner', requestData, config)
      .then(response => {
        var data = response.data;
        setResponseMessage(data.ErrorDescription);
        setAlert(true);
        setAlertType(data.ErrorCode === "1000" ? "error" : "success");
        setPopup(false);
        getApplicationBanner(0);
      })
      .catch(() => {
        setResponseMessage('Kaydetme sırasında bir hata oluştu!...');
        setAlertType('error');
        setAlert(true);
        setLoading(false);
      });
  }


  const getApplicationBanner = (IdParam) => {
    setLoading(true);
    axios.get(`/GetApolloApplicationBanner/${IdParam}`)
      .then((response) => {
        const res = response.data;
        if (IdParam === 0) {
          setBannerData(Array.isArray(res) ? res : []);
        } else {
          setId(IdParam);
          setUygulama(res[0].UygulamaId);
          setAktif(res[0].AktifId);
          setAciklama(res[0].Aciklama);
          setResim(res[0].Resim);
          setAvatarEmployee(res[0].Resim);
        }
        setLoading(false);
      })
      .catch(() => {
        setResponseMessage('Veriler alınırken bir hata oluştu!...');
        setAlertType('error');
        setAlert(true);
        setLoading(false);
      });
  }

  const bannerColumns = [
    { field: 'Id', headerName: 'Id', width: 80 },
    {
      field: 'Uygulama',
      headerName: 'Uygulama',
      flex: 1,
      minWidth: 140,
      renderCell: params => (
        <Chip
          label={params.value}
          size="small"
          sx={{
            bgcolor: getAppColor(params.value),
            color: '#fff',
            fontWeight: 600
          }}
        />
      )
    },
    { field: 'Kullanıcı', headerName: 'Kullanıcı', flex: 1, minWidth: 140 },
    {
      field: 'Aktif',
      headerName: 'Aktif',
      width: 110,
      renderCell: params => (
        <Chip
          label={Number(params.value) === 1 ? 'Aktif' : 'Pasif'}
          size="small"
          color={Number(params.value) === 1 ? 'success' : 'default'}
        />
      )
    },
    { field: 'Aciklama', headerName: 'Açıklama', flex: 1.5, minWidth: 200 },
    { field: 'BaslangicTarihi', headerName: 'Başlangıç Tarihi', width: 160 },
    { field: 'BitisTarihi', headerName: 'Bitiş Tarihi', width: 160 },
    { field: 'KayıtTarihi', headerName: 'Kayıt Tarihi', width: 160 },
    {
      field: 'Duzenle',
      headerName: 'Düzenle',
      width: 90,
      sortable: false,
      filterable: false,
      renderCell: params => (
        <IconButton
          size="small"
          onClick={() => setPopupOpen(params.row.Id)}
          aria-label="düzenle"
        >
          <EditOutlinedIcon fontSize="small" />
        </IconButton>
      )
    }
  ];

  const dateRangeInvalid = Boolean(BaslangicTarihi) && Boolean(BitisTarihi) && BitisTarihi < BaslangicTarihi;
  const activeBannerCount = BannerData.filter(item => Number(item.Aktif) === 1).length;

  return (
    <Page sx={styles.root}>
      <Backdrop style={styles.backdrop} open={Loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={Alert}
        autoHideDuration={10000}
        onClose={event => setAlert(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <AlertScreen
          onClose={event => setAlert(false)}
          variant={AlertType}
          message={ResponseMessage}
        ></AlertScreen>
      </Snackbar>
      <Container maxWidth="xl">
        <Card>
          <CardHeader
            title="Saha Uygulamaları Banner Yönetimi"
            subheader={`${BannerData.length} banner, ${activeBannerCount} aktif`}
            action={
              <Button variant="contained"
                color="secondary"
                endIcon={<AddIcon />}
                onClick={() => setPopupOpen(0)}>
                Yeni
              </Button>
            }
          />
          <Divider />
          <CardContent>
            <Box sx={{ height: 560, width: '100%' }}>
              <DataGrid
                rows={BannerData}
                columns={bannerColumns}
                getRowId={(row) => row.Id}
                initialState={{
                  pagination: {
                    paginationModel: { page: 0, pageSize: 10 }
                  }
                }}
                pageSizeOptions={[10, 25, 50]}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { placeholder: 'Ara...' }
                  }
                }}
                sx={{
                  '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 700 }
                }}
              />
            </Box>
          </CardContent>
        </Card>
      </Container>
      <Dialog
        open={Popup}
        fullWidth
        maxWidth="sm"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogHeader title={Id !== 0 ? 'Banner Düzenle' : 'Yeni Banner Ekle'} onClose={() => setPopup(false)} />
        <Divider />
        <DialogContent>
          <Grid container spacing={2}>
            {Id !== 0 && (
              <Grid
                size={{
                  xs: 12,
                  sm: 12,
                  lg: 12
                }}>
                <TextField
                  disabled
                  fullWidth
                  id="outlined-disabled"
                  label="Id"
                  defaultValue={Id}
                  variant="outlined"
                />
              </Grid>
            )}
            <Grid
              size={{
                xs: 12,
                sm: 12,
                lg: 12
              }}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel htmlFor="outlined-age-native-simple">Uygulama</InputLabel>
                <Select
                  label="Uygulama"
                  variant='outlined'
                  value={Uygulama}
                  onChange={(e) => setUygulama(e.target.value)}
                  fullWidth
                  size="small"
                >
                  <MenuItem key={0} value={0}>Uygulama Seçiniz!...</MenuItem>
                  {APP_OPTIONS.map(app => (
                    <MenuItem key={app.id} value={app.id}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Box sx={{ width: 10, height: 10, borderRadius: '50%', bgcolor: app.color }} />
                        {app.name}
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 12,
                lg: 12
              }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={Aktif === 1}
                    onChange={(e) => setAktif(e.target.checked ? 1 : 0)}
                    color="secondary"
                  />
                }
                label={Aktif === 1 ? 'Aktif' : 'Pasif'}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 12,
                lg: 12
              }}>
              <TextField
                id="filled-multiline-flexible"
                label="Açıklama"
                multiline
                fullWidth
                rows={5}
                variant="outlined"
                value={Aciklama}
                onChange={(e) => setAciklama(e.target.value)}
              />
            </Grid>
            <Grid
              size={{
                xs: 6,
                sm: 6,
                lg: 6
              }}>
              <TextField
                id="datetime-local"
                label="Başlangıç Tarihi"
                variant="outlined"
                fullWidth
                type="datetime-local"
                value={BaslangicTarihi}
                onChange={(e) => setBaslangicTarihi(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid
              size={{
                xs: 6,
                sm: 6,
                lg: 6
              }}>
              <TextField
                id="datetime-local"
                label="Bitiş Tarihi"
                variant="outlined"
                fullWidth
                type="datetime-local"
                value={BitisTarihi}
                onChange={(e) => setBitisTarihi(e.target.value)}
                error={dateRangeInvalid}
                helperText={dateRangeInvalid ? 'Başlangıç tarihinden önce olamaz' : ' '}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 12,
                lg: 12
              }}>
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                hidden
                onChange={(event) => {
                  addSelectedFiles(event.target.files);
                  event.target.value = '';
                }}
              />
              <Box
                onClick={() => fileInputRef.current?.click()}
                onDragOver={(event) => { event.preventDefault(); setIsDragActive(true); }}
                onDragLeave={() => setIsDragActive(false)}
                onDrop={handleDropFiles}
                sx={{
                  minHeight: 120,
                  border: '2px dashed',
                  borderColor: isDragActive ? '#FF9800' : '#bdbdbd',
                  borderRadius: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  backgroundColor: isDragActive ? 'rgba(255,152,0,0.05)' : 'transparent',
                  transition: 'all 0.2s ease',
                  p: 2
                }}
              >
                <Typography sx={{ color: 'text.secondary', textAlign: 'center' }}>
                  {selectedFiles.length > 0 ? selectedFiles[0].name : label}
                </Typography>
              </Box>
              {selectedFiles.length > 0 && (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                  <Button onClick={handleRemoveSelectedFile} size="small">Kaldır</Button>
                </Box>
              )}
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                sx={{ mt: 1 }}
                disabled={selectedFiles.length === 0}
                onClick={handleUploadClick}
              >
                Yükle
              </Button>
              {uploadSuccess && selectedFiles.length === 0 && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 1, color: 'success.main' }}>
                  <CheckCircleOutlineIcon fontSize="small" />
                  <Typography variant="caption">Görsel yüklendi</Typography>
                </Box>
              )}
            </Grid>
            <Grid
              size={{
                xs: 12,
                sm: 12,
                lg: 12
              }}>
              {avatarEmployee ? (
                <StyledCardMedia
                  component="img"
                  alt="Banner"
                  src={avatarEmployee}
                />
              ) : (
                <Box
                  sx={{
                    height: 200,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1,
                    color: 'text.disabled',
                    border: '1px dashed',
                    borderColor: 'divider',
                    borderRadius: 2
                  }}
                >
                  <ImageOutlinedIcon fontSize="large" />
                  <Typography variant="caption">Henüz görsel yüklenmedi</Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button
            variant="text"
            color="secondary"
            onClick={(event) => { setPopup(false); }}
          >
            Kapat
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={(event) => { handleSave() }}
            endIcon={<SaveIcon />}
          >
            Kaydet
          </Button>
        </DialogActions>
      </Dialog>
    </Page >
  );
}
export default Banner;
